import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TouchableHighlight,
  Switch,
  Linking,
  Platform,
} from "react-native";
import { globalFontStyle, globalStyle } from "../../../assets";
import Width from "../../../assets/Width";
import CommonModal from "../../../commonComponents/commonModal";
import Tooltip from "react-native-walkthrough-tooltip";
import Colors from "../../../assets/Color/Colors";
import { Button } from "../../../components/core/Button";
import { info } from "../../../utils/images";
import { useSelector } from "react-redux";
import FastImage from "../../../common/FastImage";
import { isMobile } from "../../../utils/commonMethods";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData, globalConst, GlobalScreens} from "../../../utils/globalConstant";

const Slippage = ({ slippages, handleSlippage }) => {
  const [showSlip, setShowSlip] = useState(false);
  const [toolTipVisible, setToolTipVisible] = useState(false);
  let globalConfigData = useSelector(
    ({ utilReducer }) => utilReducer.globalConfigData
  );

  const onLearnMore = () => {
    Linking.openURL(
      globalConfigData?.slippageAcademy
        ? globalConfigData?.slippageAcademy
        : "https://tradexapp.zendesk.com/hc/en-us/articles/6465700071581-How-do-I-prevent-Slippage-"
    );
  };

  const onSlippageOpen = () => {
    setShowSlip(!showSlip);
  };
  return (
    <View style={{ position: "relative" }}>
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <Tooltip
          isVisible={toolTipVisible}
          contentStyle={[
            globalStyle.toolTipStyle,
            !isMobile() ? { flex: 1, minWidth: 150 } : {minWidth: 350},
          ]}
          content={
            <View style={{}}>
              <FormTextLabel
                  labelStyles={{
                    ...globalFontStyle.appFontSubText,
                    color: globalConfigurableData.primaryTextColor1,
                  }}
                  label={"Slippage is when the price at which your order is executed does not match the displayed price. \n \n If Limited Slippage is ON, your order will only be executed if final share price is between (+/-) ₹5 of displayed price.\n\n If limited slippage is OFF, your will get fully executed at any closest available share prices.\n"}
              />
              {globalConst.partnerId ===1 && (<TouchableOpacity activeOpacity={0.8} onPress={onLearnMore}>
                <FormTextLabel
                    labelStyles={{
                      ...globalFontStyle.appFontSubTextBold,
                      color: GlobalScreens.SingleOrder.highlightColor,
                    }}
                    label={"Learn More"}
                />
              </TouchableOpacity>)}
            </View>
          }
          placement="top"
          onClose={() => setToolTipVisible(false)}
          showChildInTooltip={false}
          disableShadow={true}
          backgroundColor={"rgba(0,0,0)"}
          allowChildInteraction={true}
        >
          <TouchableHighlight
            style={globalStyle.infoIcon}
            onPress={() => setToolTipVisible(true)}
          >
            <FastImage style={styles.infoStyle} source={globalConfigurableData?.info()} />
          </TouchableHighlight>
        </Tooltip>
        <FormTextLabel
            labelStyles={styles.slippageText}
            label={slippages ? "Limited Slippage" : "Unlimited Slippage"}
        />
        <Switch
          style={
            Platform.OS === "ios"
              ? { transform: [{ scaleX: 0.8 }, { scaleY: 0.8 }], marginLeft: 8 }
              : { height: 14, marginLeft: 8 }
          }
          trackColor={{ false: globalConfigurableData.lossColor, true: globalConfigurableData.profitColor }}
          thumbColor={Colors.bgWhite}
          ios_backgroundColor={Colors.red}
          onValueChange={handleSlippage}
          value={slippages}
        />
      </View>
      <CommonModal
        onModalCallBack={onSlippageOpen}
        customModalStyle={[styles.modalView]}
        showModal={showSlip}
        parentStyles={styles.parents}
        animationType={"none"}
      >
        <View style={{ width: 230, paddingHorizontal: 10 }}>
          <Text style={styles.slippageTitle}>Slippage Tolerance</Text>

          <View style={{ flexDirection: "row", marginTop: 10 }}>
            <Button
              variant={!slippages ? "primary" : "grey"}
              size="default"
              onPress={handleSlippage}
              style={[
                styles.btnExternalStyle,
                { marginRight: 10, paddingVertical: 8 },
              ]}
            >
              Unlimited
            </Button>
            <Button
              variant={slippages ? "primary" : "grey"}
              size="default"
              onPress={handleSlippage}
              style={[styles.btnExternalStyle, { paddingVertical: 8 }]}
            >
              Limited
            </Button>
          </View>
          <Text style={[styles.confirmNote, { marginTop: 5 }]}>
            (Confirmed order execution at best possible price)
          </Text>
        </View>
      </CommonModal>
    </View>
  );
};

export default Slippage;

const styles = StyleSheet.create({
  parents: {
    backgroundColor: "transparent",
    //position: 'absolute',
    //justifyContent: 'flex-end',
    //alignItems: 'flex-end',
  },
  modalView: {
    backgroundColor: "white",
    borderRadius: 20,
    paddingHorizontal: 10,
    paddingTop: 16,
    paddingBottom: 10,

    position: "absolute",
    //width: Width.width / 2,
    right: 20,
    //bottom: 0,
    //alignItems: 'center',
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 6,
  },
  confirmNote: {
    ...globalFontStyle.appSmall8,
    color: Colors.tradexBlue,
  },
  slippageTitle: {
    ...globalFontStyle.appSmall10Bold,
    color: Colors.black,
  },
  infoStyle: {
    width: 15,
    height: 15,
  },
  slippageText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.primaryTextColor1,
  },
});
